import {
  Box,
  Tooltip,
  Typography,
  createTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React, { useEffect, useState } from "react";
import dottedline from "../../../asset/dottedline.svg";
import Third from "./Third";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPsychometricTestStatusAsync } from "src/redux/services/psycometricServices";
import { getStudyAbroadStatusAsync } from "src/redux/services/studyAbroadServices";

export default function Second({
  setCategoryAbout,
  selectedCategory,
  categoryAbout,
  urlStatus,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const ScreenFor = createTheme({
    breakpoints: {
      values: {
        s1: 806,
        s2: 956,
        xs: 300,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1600,
      },
    },
  });
  const isSmallScreen = useMediaQuery(ScreenFor.breakpoints.down("xs"));
  const isMediumScreen = useMediaQuery(ScreenFor.breakpoints.down("sm"));
  const specialScreenFor = useMediaQuery(
    ScreenFor.breakpoints.between("s1", "s2"),
  );
  const xsFor = useMediaQuery(ScreenFor.breakpoints.between("xs", "sm"));
  const smFor = useMediaQuery(ScreenFor.breakpoints.between("sm", "md"));

  const titleStatusMap = {
    Counselling: "counselling",
    "Profile Building": "profile",
    "Psychometric Test": "psychometric",

    Career: "career",

    "Test Preparation": "test",
    "LORs/ Essays/ SOPs": "lor",
    Scholarship: "scholarship",

    "Education Loan": "educationloan",
    "VISA/TRAVEL & FOREX": "visa",
    ACCOMMODATION: "accommodation",
  };

  const handleChangeProcess = (e, title, actionType) => {
    if (e) e.preventDefault();

    const statusSlug = titleStatusMap[title];

    navigate(
      `/dashboard/studyabroad?category=${selectedCategory}&status=${statusSlug}`,
    );

    setCategoryAbout({
      title,
      actionType,
      category: selectedCategory,
    });

    setShow(true);
  };

  const { getPsychometricTestStatus } = useSelector(
    (state) => state.psychometric,
  );

  const psychometricStatus = getPsychometricTestStatus?.psychometricTestStatus;

  const { dashboardData, isLoading } = useSelector(
    (state) => state.studyAbroad,
  );

  useEffect(() => {
    dispatch(getStudyAbroadStatusAsync());
  }, [dispatch]);

  const allData = {
    personalized: [
      {
        title: "Counselling",
        actionType: isLoading ? "loading..." : dashboardData?.counselling,
      },
      {
        title: "Profile Building",
        actionType: isLoading ? "loading..." : dashboardData?.profileBuilding,
      },
      {
        title: "Psychometric Test",
        actionType: isLoading ? "loading..." : dashboardData?.psychometric,
        isApproved: !psychometricStatus,
      },
    ],

    career: [
      {
        title: "Career",
        actionType: isLoading ? "loading..." : dashboardData?.universities,
      },
    ],

    admission: [
      {
        title: "Test Preparation",
        actionType: isLoading ? "loading..." : dashboardData?.testPreparation,
      },
      {
        title: "LORs/ Essays/ SOPs",
        actionType: isLoading ? "loading..." : dashboardData?.lorSopEssay,
      },
      {
        title: "Scholarship",
        actionType: isLoading ? "loading..." : dashboardData?.application,
      },
    ],
    post: [
      {
        title: "Education Loan",
        actionType: isLoading
          ? "loading..."
          : dashboardData?.educationLoanSupport,
      },
      {
        title: "VISA/TRAVEL & FOREX",
        actionType: isLoading
          ? "loading..."
          : dashboardData?.visaSupportAndTravel,
      },
      {
        title: "ACCOMMODATION",
        actionType: isLoading
          ? "loading..."
          : dashboardData?.accommodationSupport,
      },
    ],
  };

  const statusTitleMap = {
    counselling: "Counselling",
    profile: "Profile Building",
    psychometric: "Psychometric Test",

    career: "Career",

    test: "Test Preparation",
    lor: "LORs/ Essays/ SOPs",
    scholarship: "Scholarship",

    educationloan: "Education Loan",
    visa: "VISA/TRAVEL & FOREX",
    accommodation: "ACCOMMODATION",
  };

  React.useEffect(() => {
    if (!selectedCategory || !allData[selectedCategory]?.length) return;

    // URL status based item
    const matchedTitle = statusTitleMap[urlStatus];

    const matchedItem = allData[selectedCategory]?.find(
      (item) => item.title === matchedTitle,
    );

    const defaultItem = matchedItem || allData[selectedCategory][0];

    handleChangeProcess(null, defaultItem.title, defaultItem.actionType);
  }, [selectedCategory, urlStatus]);

  useEffect(() => {
    dispatch(getPsychometricTestStatusAsync());
  }, [dispatch]);

  return (
    <>
      <Box
        sx={{
          width: {
            xs: "95%",
            sm: "90%",
          },
          height: "auto",
          padding: "auto",
          margin: "auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          py: 4,
        }}
        onClick={() => setShow(true)}
      >
        {allData[selectedCategory]?.map((item, index) => {
          const isLastBox = index === allData[selectedCategory].length - 1;
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                mx: {
                  xs: 1,
                  sm: "auto",
                },
                my: {
                  xs: 1,
                  sm: "auto",
                },
                opacity: item?.isApproved ? 0.5 : 1,
                pointerEvents: item?.isApproved ? "none" : "auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "center",
                  },
                  alignItems: "center",
                  gap: {
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg: 4,
                  },
                  flexWrap: "wrap",
                  flexDirection: {
                    xs: show ? "column" : "row",
                    sm: "row",
                  },
                  my: {
                    xs: 2,
                  },
                }}
              >
                <Box
                  sx={{
                    width: "auto",
                    height: "125px",
                    padding: {
                      xs: "10px",
                      sm: "10px",
                      md: "10px",
                      lg: "16px",
                    },
                    gap: {
                      xs: "5px",
                      sm: "5px",
                      md: "10px",
                      lg: "20px",
                    },
                    borderRadius: "12px",
                    backgroundColor: "#00999E",
                    color: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    cursor: "pointer",
                    my: {
                      md: 3,
                      sm: 3,
                    },
                  }}
                  onClick={(e) =>
                    handleChangeProcess(e, item?.title, item?.actionType)
                  }
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "150px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {item?.title}
                    </Typography>
                    <Tooltip
                      title={item?.actionType || ""}
                      arrow
                      placement="top"
                    >
                      <Box
                        sx={{
                          bgcolor: "#B1FCFF",
                          width: "fit-content",
                          borderRadius: 5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mt: 1,
                          padding: "3px 8px",
                        }}
                      >
                        <Box
                          sx={{
                            height: "18px",
                            width: "18px",
                            border: `5px solid ${
                              item?.actionType === "In Progress"
                                ? "white"
                                : item?.actionType === "Completed"
                                ? "white"
                                : item?.actionType === "Not Taken"
                                ? "#828282"
                                : item?.actionType === "Not Required"
                                ? "white"
                                : "white"
                            }`,
                            borderRadius: "50%",
                            backgroundColor: `${
                              item?.actionType === "Awaiting Action"
                                ? "#F67A07"
                                : item?.actionType === "Completed"
                                ? "#20CF10"
                                : item?.actionType === "Not Applicable"
                                ? "#1C1C1C"
                                : item?.actionType === "In Progress"
                                ? "yellow"
                                : "white"
                            }`,
                            mr: 1,
                            mb: 0.3,
                          }}
                        />

                        <Typography
                          sx={{
                            color: "black",
                            fontSize: "12px",
                            maxWidth: "80px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item?.actionType}
                        </Typography>
                      </Box>
                    </Tooltip>
                  </Box>
                </Box>

                {isSmallScreen
                  ? show &&
                    item.title === categoryAbout.title && (
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItem: "center",
                          flexDirection: "column",
                          paddingTop: "20px",
                          marginRight: {
                            xs: 0,
                            sm: 8,
                          },
                        }}
                      >
                        <img
                          src={dottedline}
                          alt="dotted-line"
                          width={5}
                          height={80}
                          style={{ margin: "auto" }}
                        />
                        <KeyboardArrowDownIcon sx={{ color: "#00999E" }} />
                      </Box>
                    )
                  : !isLastBox && <ArrowForwardIosIcon />}
              </Box>
              {(isSmallScreen || isMediumScreen) &&
                show &&
                item.title === categoryAbout.title && (
                  <>
                    {show && (isSmallScreen || isMediumScreen) && (
                      <Box>
                        <Third categoryAbout={categoryAbout} />
                      </Box>
                    )}
                  </>
                )}
              {!isSmallScreen && show && item.title === categoryAbout.title && (
                <Box
                  sx={{
                    height: xsFor
                      ? "auto"
                      : smFor
                      ? "auto"
                      : specialScreenFor
                      ? "auto"
                      : "0px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItem: "center",
                      flexDirection: "column",
                      paddingTop: "10px",
                      marginRight: {
                        xs: 0,
                        sm: 8,
                      },
                    }}
                  >
                    <img
                      src={dottedline}
                      alt="dotted-line"
                      width={5}
                      height={80}
                      style={{ margin: "auto" }}
                    />
                    <KeyboardArrowDownIcon sx={{ color: "#00999E" }} />
                  </Box>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
      {show && !isSmallScreen && (
        <Box sx={{ mt: 12 }}>
          <Third categoryAbout={categoryAbout} />
        </Box>
      )}
    </>
  );
}
